module.exports = __webpack_public_path__ + "img/default.121c310c.jpg";